import {
    AppstoreAddOutlined,
    AppstoreOutlined,
    HomeOutlined,
    LogoutOutlined,
    OrderedListOutlined,
    ProfileOutlined,
    UserOutlined,
    CreditCardOutlined,
    BulbOutlined,
    RobotOutlined,
    GlobalOutlined,
    CloudUploadOutlined,
    OpenAIOutlined,
    SisternodeOutlined,
    RocketOutlined,
    ContactsOutlined,
    LockOutlined,
} from "@ant-design/icons";
import { Button, Menu, message, Switch, Typography, Row, Col, Popover } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import useDarkMode from "../../hooks/useDarkMode";
import useProDashboard from "../../hooks/useProDashboard";
import HTTPClient from "../../utils/HTTPClient";
import { AppboxLanguageSelect } from "../../components";
import { DashboardProSelect } from "../../components";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

const { SubMenu } = Menu;



const AppSider = (props) => {
    const [user, setUser] = useLocalStorage("user", null);
    const [selectedKeys, setSelectedKeys] = useState(["3"]);
    const [openKeys, setOpenKeys] = useState([]);

    const { t } = useTranslation();

    const navigate = useNavigate();

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 1310px)",
    });

    const getItem = (label, key, icon, onClick, children, minPlan) => {
        if (!user.plan) user.plan = "free";
        const plans = ["free", "pro", "business", "enterprise"];
        const isDisabled = plans.indexOf(user.plan) < plans.indexOf(minPlan);
        return {
            key,
            icon: icon,
            children,
            onClick: isDisabled ? null : onClick,
            label,
            disabled: isDisabled,
        };
    };

    const executeLogout = async () => {
        HTTPClient.post("/auth/logout")
            .then((res) => {
                message.success(t("pro_sider.logout.success"));
                setUser(null);
                navigate("/login");
            })
            .catch((e) => {
                message.error(t("pro_sider.logout.error"));
            });
    };

    const manageStripe = async () => {
        try {
            await HTTPClient.post("/stripe/create_portal_session");
        } catch (e) {
            if (e.response.status === 303) {
                window.location.replace(e.response.data);
                return;
            }
            message.error(e.response.data);
        }
    };

    const moveTo = (route) => {
        navigate(route);
    };

    const items = [
        getItem(t("sider.items.home"), "2", <HomeOutlined />, () => moveTo("/home"), [], "free"),
        getItem(t("sider.items.website"), "3", <GlobalOutlined />, () => moveTo("/website"), [], "pro"),
        getItem(t("sider.items.flow"), "4", <SisternodeOutlined />, () => moveTo("/flow"), [], "pro"),
        getItem(t("sider.items.crm"), "9", <ContactsOutlined />, () => moveTo("/crm"), [], "business"),
        getItem(t("sider.items.ai-studio"), "5", <OpenAIOutlined />, () => moveTo("/ai-studio"), [], "pro"),
        getItem(t("sider.items.ai-assistant"), "10", < RobotOutlined />, () => moveTo("/ai-assistant"), [], "business"),

        getItem(`${user?.name} ${user?.surname || ""}`, "sub1", <UserOutlined />, () => { }, [
            getItem(t("sider.items.profile"), "1", <ProfileOutlined />, () => moveTo("/profile"), [], "free"),
            getItem(t("sider.items.stripe"), "6", <CreditCardOutlined />, manageStripe, [], "pro"),
            getItem(t("sider.items.logout"), "8", <LogoutOutlined />, executeLogout, [], "free"),
        ], "free"),
    ];

    useEffect(() => {
        setSelectedKey(window.location.pathname);
    }, [window.location.pathname]);

    const setSelectedKey = (pathname) => {
        const isPresent = PATHNAME_MAP[pathname];
        if (isPresent) {
            setSelectedKeys(isPresent);
            //setOpenKeys(isPresent.slice(0, -1)); // Apre i sottomenu fino all'ultimo livello
        }
    };

    const PATHNAME_MAP = {
        "/profile": ["sub1", "1"],
        "/home": ["2"],
        "/website": ["3"],
        "/flow": ["4"],
        "/ai-studio": ["5"],
        "/crm": ["9"],
        "/ai-assistant": ["10"],
    };

    const handleOpenChange = (keys) => {
        setOpenKeys(keys);
    };

    return (
        <Row style={{ width: isLargeScreen ? "300px" : "100%", height: isLargeScreen ? "auto" : "100%" }}>
            {isLargeScreen && <a href="/home" style={{ padding: "15px" }}>
                <img
                    src="/logo_bianco.png"
                    alt="logo"
                    width={"100%"}
                    id="sider_logo"
                />
            </a>}
            <Menu
                selectedKeys={selectedKeys}
                openKeys={openKeys}
                onOpenChange={handleOpenChange}
                mode="inline"
                style={{
                    height: "75%",
                    borderRight: 0,
                    backgroundColor: "#1C2347",
                    color: "white",
                }}>
                {items.map((item) =>
                    item.children && item.children.length > 0 ? (
                        <SubMenu key={item.key} icon={item.icon} title={item.label}>
                            {item.children.map((subItem) => (
                                <Menu.Item
                                    id={subItem.key}
                                    key={subItem.key}
                                    icon={subItem.icon}
                                    onClick={subItem.onClick}
                                    disabled={subItem.disabled}
                                    style={{ color: subItem.disabled ? "rgba(255, 255, 255, 0.5)" : "white", cursor: subItem.disabled ? "default" : "pointer", }}>
                                    {subItem.label}
                                </Menu.Item>
                            ))}
                        </SubMenu>
                    ) : (
                        <Menu.Item id={"menu" + item.key} key={item.key} icon={item.icon} onClick={item.onClick}
                            style={{ color: item.disabled ? "rgba(255, 255, 255, 0.5)" : "white", cursor: item.disabled ? "default" : "pointer", }}>
                            {item.label}{item.disabled && (
                                <Popover title={t("sider.items.disabled")} content={t("sider.items.disabled_text")}>
                                    <span
                                        style={{ marginLeft: "20px", width: "40px", backgroundColor: "#5F4DEE", borderRadius: "5px", padding: "5px" }}>
                                        <LockOutlined style={{ color: "rgba(255, 255, 255, 0.5)" }} />
                                    </span>
                                </Popover>
                            )}
                        </Menu.Item>
                    )
                )}



                {props.showLang && (
                    <div style={{ display: "flex", justifyContent: "flex-start", paddingLeft: "24px" }}>
                        <AppboxLanguageSelect />
                    </div>
                )}
            </Menu>
            <Row style={{ width: "100%", height: "100%", backgroundColor: "#1C2347" }}>

                <Col style={{
                    backgroundImage: "url('/box_supporto.png')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundColor: "#FAFAFA",
                    height: "100px",
                    width: "260px",
                    margin: "20px",
                    padding: "15px",
                    alignItems: "center",
                    position: "absolute",
                    bottom: "5%",
                    borderRadius: 14,
                }}>
                    <Row>
                        <Typography.Title style={{ marginTop: "0px", color: "#5F4DEE", fontSize: 18, fontWeight: 700 }}>
                            {t("sider.support.title")}
                        </Typography.Title>
                    </Row>
                    <Row>
                        <Typography.Text style={{ fontSize: 16, color: "#5F4DEE" }}>
                            <a href="mailto:support@appbox.cloud">{t("sider.support.email")}</a>
                        </Typography.Text>
                    </Row>
                </Col>
            </Row>
        </Row>
    );
};

export default AppSider;
